// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2IT5H","buttons":"RemoveExpirationActionButtons_buttons__6NN_E"};